import axios from 'axios'
import serverUrl from '@/assets/BaseServerUrl.js'

const messagesService = {
  async getConversation(userId, peerId) {
    const res = await axios.get(`${serverUrl}/api/messages/conversation`, { params: { userId, peerId } })
    return res.data
  },
  async sendMessage(fromUserId, toUserId, content) {
    const res = await axios.post(`${serverUrl}/api/messages/send`, { fromUserId, toUserId, content })
    return res.data
  },
  async markRead(userId, peerId) {
    const res = await axios.post(`${serverUrl}/api/messages/mark-read`, { userId, peerId })
    return res.data
  },
  async getUnreadCount(userId) {
    const res = await axios.get(`${serverUrl}/api/messages/unread-count`, { params: { userId } })
    return res.data
  },
  async getNotifications(userId) {
    const res = await axios.get(`${serverUrl}/api/messages/notifications`, { params: { userId } })
    return res.data
  },
  async markNotificationsRead(userId, notifIds) {
    const res = await axios.post(`${serverUrl}/api/messages/notifications/mark-read`, { userId, notifIds })
    return res.data
  },
  async getChatPartners(userId) {
    const res = await axios.get(`${serverUrl}/api/messages/chat-partners`, { params: { userId } })
    return res.data
  },
  async submitAuditAppeal(payload) {
    const token = localStorage.getItem('userToken') || localStorage.getItem('token') || ''
    const headers = token ? { Authorization: `Bearer ${token}` } : {}
    const res = await axios.post(`${serverUrl}/api/audit/appeal`, payload, { headers })
    return res.data
  }
}

export default messagesService
